export default __webpack_public_path__ + "static/media/waff.170c0656.png";